import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getModerationItemsKey } from '../../utils/keys';
export const useCreateModerationReport = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const moderationItemsKey = getModerationItemsKey();
    return useMutation(variables => client.mutation({
        name: 'createModerationReport',
        args: {
            variables,
            fields,
        },
    }), {
        onSettled: () => {
            // invalidate to refetch again
            queryClient.invalidateQueries(moderationItemsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useCreateModerationReport.js.map